import * as React from "react";
const SVGComponent = ({ bgcolor, border, color, ...props }) => (
  <svg
    width={31}
    height={30}
    viewBox="0 0 31 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={0.900391}
      y={0.5}
      width={29}
      height={29}
      rx={5.5}
      fill={bgcolor}
      stroke={border}
    />
    <path
      d="M20.8993 10.2125C21.2067 9.92351 21.3848 9.52289 21.3934 9.10102C21.402 8.67931 21.2404 8.27181 20.945 7.97051C20.6496 7.66935 20.2453 7.49968 19.8234 7.5H10.0795C9.9011 7.5 9.73004 7.57083 9.604 7.69702C9.47782 7.82305 9.40698 7.99412 9.40698 8.17253V24.8275C9.40698 25.0678 9.5352 25.2897 9.74317 25.4099C9.95129 25.53 10.2077 25.53 10.4157 25.4099C10.6238 25.2897 10.752 25.0678 10.752 24.8275V18.9525H19.8214C20.2436 18.9534 20.6482 18.7841 20.9441 18.483C21.2399 18.1819 21.402 17.7742 21.3936 17.3522C21.3852 16.93 21.2071 16.5291 20.8995 16.24L17.8688 13.3887C17.8236 13.3463 17.7978 13.2871 17.7978 13.225C17.7978 13.1631 17.8236 13.1038 17.8688 13.0614L20.8993 10.2125Z"
      fill={color}
    />
  </svg>
);
export default SVGComponent;
